import axiosInstance from "../../utils/axiosInstance";
import {REPORT_PARAMETER_ACTION_TYPES} from "../typesAction";


export const setLoading = () => {
    return {type: REPORT_PARAMETER_ACTION_TYPES.LOAD_REPORT_PARAMETER}
};

export const clearLoading = () => {
    return {type: REPORT_PARAMETER_ACTION_TYPES.CLEAR_LOAD_REPORT_PARAMETER}
};

export const clearReportParameterError = () => {
    return {type: REPORT_PARAMETER_ACTION_TYPES.CLEAR_REPORT_PARAMETER_ERRORS}
};

export const listReportParameters = (history, pagination, filters = {}, sorter) => async dispatch => {
    try {
        dispatch(setLoading());
        // Prepare all query parameters
        let queryParameters = {};
        Object.keys(filters).map(key => (
            queryParameters[key] = filters[key] == null ? filters[key] : filters[key][0])
        );
        if (sorter !== undefined) {
            queryParameters['sort'] = sorter['field'];
            queryParameters['order'] = sorter['order'] === 'descend' ? 'desc' : 'asc'
        }
        if (pagination !== undefined) {
            queryParameters['offset'] = (pagination.current - 1) * pagination.pageSize;
            queryParameters['max'] = pagination.pageSize
        }
        // Spread the parameters
        const params = {
            ...queryParameters
        };
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).get('/reportParameter', {params});
        // Update state
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.LIST_REPORT_PARAMETER,
            payload: data
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.ERROR_REPORT_PARAMETER,
            payload: err.message
        });
    }
};

export const addReportParameter = (history, reportParameter, setReportParameterCreated) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).post('/reportParameter', reportParameter);
        // Update state
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.ADD_REPORT_PARAMETER,
            payload: data
        });
        if (setReportParameterCreated) setReportParameterCreated(true);
    } catch (err) {
        console.log(err);
        const error = await err.response.data;
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.ERROR_REPORT_PARAMETER,
            payload: error
        });
    }
};

export const getReportParameter = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request
        const {data} = await axiosInstance(history, dispatch).get(`/reportParameter/${id}`);
        // Update state
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.SHOW_REPORT_PARAMETER,
            payload: data
        });
        return data;
    } catch (err) {
        console.log(err);
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.ERROR_REPORT_PARAMETER,
            payload: err.message
        });
    }
};

export const editReportParameter = (history, id, reportParameter, setReportParameterCreated = null) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).patch(`/reportParameter/${id}`, reportParameter);
        // Update state
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.EDIT_REPORT_PARAMETER,
            payload: data
        });
        if (setReportParameterCreated !== null) setReportParameterCreated(true)
    } catch (err) {
        console.log(err);
        const error = await err.response.data;
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.ERROR_REPORT_PARAMETER,
            payload: error
        });
    }
};

export const deleteReportParameter = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request
        await axiosInstance(history, dispatch).delete(`/reportParameter/${id}`);
        // Update state
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.DELETE_REPORT_PARAMETER,
            payload: id
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: REPORT_PARAMETER_ACTION_TYPES.ERROR_REPORT_PARAMETER,
            payload: err.message
        });
    }
};
